// import Swal from 'sweetalert2'
const lib = {}

// lib.Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 3000,
//   timerProgressBar: true,
//   didOpen: (toast) => {
//     toast.addEventListener('mouseenter', Swal.stopTimer)
//     toast.addEventListener('mouseleave', Swal.resumeTimer)
//   },
// })

lib.consts = {
  roles: {
    SU: 1,
    ADMIN: 2,
    ADMIN_ACADEMICO: 3,
    COORDINADOR: 4,
    GESTOR_ACADEMICO: 5,
    DOCENTE: 6,
    ESTUDIANTE: 7,
    PADRE_MADRE: 8,
    VISITANTE: 9,
    ADMIN_RESTAURANTE: 10,
    CAJERO: 11,
    RECARGADOR: 12,
    CONTADOR: 13,
    BIBLIOTECARIO: 14,
    FUNCIONARIO: 15,
    SUPERVISOR_RESTAURANTE: 16,
    PSICOLOGO: 17,
  },
  params: {
    COMBO: 'COMBO',
    INVENTORY: 'INVENTORY',
    ORDER: 'ORDER',
    MASSIVE_RECHARGE: 'MASSIVE_RECHARGE',
    NOTIFICATION_CAFETERIA: 'NOTIFICATION_CAFETERIA',
    NOTIFICATION_OBSERVER: 'NOTIFICATION_OBSERVER',
    ONLINE_RECHARGE: 'ONLINE_RECHARGE',
    IS_CAFETERIA: 'CAFETERIA',
    IS_OBSERVER: 'OBSERVER',
    IS_EPAYCO: 'EPAYCO',
  },
  ID_PARAM: {
    ONLINE_RECHARGE: 21,
  },
  SPECIFIC_PARAM: {
    BUY: 'BUY',
    RECHARGE: 'RECHARGE',
    OBSERVER: 'OBSERVER',
    BUY_SONS: 'BUY_SONS',
    RECHARGE_SONS: 'RECHARGE_SONS',
    OBSERVER_SONS: 'OBSERVER_SONS',
  },
  permissions: {
    CREATE_INVOICE: 'createInvoice',
    CREATE_PRODUCT: 'createProduct',
    EDIT_PRODUCT: 'editProduct',
    CREATE_RECHARGE: 'createRecharge',
    READ_OWN_RECHARGE: 'readOwnRecharge',
    DELETE_RECHARGE: 'deleteRecharge',
    STATISTICS_OWN_RECHARGES_SALES: 'statisticsOwnRechargesSales',
    STATISTICS_RECHARGES_SALES: 'statisticsRechargesSales',
    READ_SALES: 'readSales',
    DELETE_SALE: 'deleteSale',
    DELETE_PRODUCT_SALE: 'deleteProductSale',
    CREATE_SU_MANAGEMENT: 'createSUManagement',
    UPDATE_SU_MANAGEMENT: 'updateSUManagement',
    DELETE_SU_MANAGEMENT: 'deleteSUManagement',
    READ_ACADEMIC_INFORMATION: 'readAcademicInformation',
    CREATE_CLASSES_RESOURCES: 'createClassesResources',
    UPDATE_CLASSES_RESOURCES: 'updateClassesResources',
    DELETE_CLASSES_RESOURCES: 'deleteClassesResources',
    CREATE_ACADEMIC_MANAGEMENT: 'createAcademicManagement',
    UPDATE_ACADEMIC_MANAGEMENT: 'updateAcademicManagement',
    READ_USERS: 'readUsers',
    CREATE_USER: 'createUser',
    UPDATE_USER: 'updateUser',
    UPDATE_USER_PASSWORD: 'updateUserPassword',
    UPDATE_USER_PHOTO: 'updateUserPhoto',
    UPDATE_USER_CODE_CARD: 'updateUserCodeCard',
    DELETE_USER: 'deleteUser',
    DOWNLOAD_STUDENT_REPORT: 'downloadStudentReport',
    DOWNLOAD_GROUP_BASE__REPORT: 'downloadGroupBaseReport',
    DOWNLOAD_GROUP_FULL_REPORT: 'downloadGroupFullReport',
    READ_CONTROL_PARENTAL: 'readControlParental',
    CREATE_CONTROL_PARENTAL: 'createControlParental',
    EDIT_CONTROL_PARENTAL: 'editControlParental',
    DELETE_CONTROL_PARENTAL: 'deleteControlParental',
    CREATE_OBSERVATIONS: 'createObservations',
    READ_OBSERVATIONS: 'readObservations',
    UPDATE_OBSERVATIONS: 'editObservations',
    DELETE_OBSERVATIONS: 'deleteObservations',
    READ_OBSERVATIONS_CHILDREN: 'readObservationChildren',
    READ_EMPLOYEE: 'readEmployee',
    READ_EMPLOYEES: 'readEmployees',
    CREATE_EMPLOYEE: 'createEmployee',
    DELETE_EMPLOYEE: 'deleteEmployee',
    EDIT_EMPLOYEE: 'editEmployee',
    DISABLE_EMPLOYEE: 'disableEmployee',
    READ_PAYROLL_SETTINGS: 'readPayrollSettings',
    CREATE_PAYROLL_SETTINGS: 'createPayrollSettings',
    EDIT_PAYROLL_SETTINGS: 'editPayrollSettings',
    DELETE_PAYROLL_SETTINGS: 'deletePayrollSettings',
  },
  rolesText: {
    SU: 'SU',
    ADMIN: 'ADMIN',
    ADMIN_ACADEMICO: 'ADMIN_ACADEMICO',
    COORDINADOR: 'COORDINADOR',
    GESTOR_ACADEMICO: 'GESTOR_ACADEMICO',
    DOCENTE: 'DOCENTE',
    ESTUDIANTE: 'ESTUDIANTE',
    PADRE_MADRE: 'PADRE_MADRE',
    VISITANTE: 'VISITANTE',
    ADMIN_RESTAURANTE: 'ADMIN_RESTAURANTE',
    CAJERO: 'CAJERO',
    RECARGADOR: 'RECARGADOR',
    CONTADOR: 'CONTADOR',
    BIBLIOTECARIO: 'BIBLIOTECARIO',
    FUNCIONARIO: 'FUNCIONARIO',
    SUPERVISOR_RESTAURANTE: 'SUPERVISOR_RESTAURANTE',
    PSICOLOGO: 'PSICOLOGO',
  },
  RECHARGE_TYPE: [
    { item: '1', name: 'Efectivo' },
    { item: '2', name: 'Transferencia' },
    { item: '3', name: 'Pasarela', notEnabled: true },
  ],
  FILTER_RECHARGE_TYPE: [
    { value: null, text: 'Seleccione el tipo de recarga' },
    { value: '1', text: 'Efectivo' },
    { value: '2', text: 'Transferencia' },
    { value: '3', text: 'Pasarela' },
  ],
  RECHARGE_CASH: '1',
  RECHARGE_TRANSFER: '2',
  RECHARGE_PAYMENT_GATEWAY: '3',
  ENROLLMENT_STEP: {
    DATA: '1',
    SIGN: '2',
    SUPPORT: '3',
  },
  ENROLLMENT_TEXT_STEP: {
    DATA: 'Datos',
    SIGN: 'Firmas',
    SUPPORT: 'Soporte',
  },
  ENROLLMENT_STATE: {
    PROGRESS: '1',
    REJECT: '2',
    OK: '3',
    MATRICULATE: '4',
  },
  ENROLLMENT_TEXT_STATE: {
    PROGRESS: 'En proceso',
    REJECT: 'No aprobado',
    OK: 'Completado',
    MATRICULATE: 'Matriculado',
  },
  TEMPLATE_TYPE: {
    UPLOAD: 'UPLOAD',
    DOWNLOAD: 'DOWNLOAD',
  },
  TYPE_OBSERVATION: {
    SITUATION_I: 'I',
    SITUATION_II: 'II',
    SITUATION_III: 'III',
    TYPE_POSITIVE: 'POSITIVA',
    TYPE_ATTENTION: 'LLAMADO DE ATENCIÓN',
    TYPE_FOLLOW_UP: 'SEGUIMIENTO',
    NA: 'N/A',
  },
}

lib.getRoleNameById = (id) => {
  for (const key in lib.consts.roles) {
    if (lib.consts.roles[key] === id) {
      return key
    }
  }
}

lib.hasRole = (roles, role) => {
  return roles.includes(role)
}

lib.hasPermission = (permissionsAllowed, userPermissions) => {
  if (permissionsAllowed === undefined || !userPermissions) {
    return false
  } else {
    for (const permission of userPermissions) {
      if (permissionsAllowed.includes(permission)) {
        return true
      }
    }
    return false
  }
}

lib.isOnlyDigits = (e) => { // solo numeros sin puntos ni nada
  return /^[0-9]+$/.test(e)
}

lib.isOnlyText = (e) => { // letras sin acento. espacios, insensitive
  return /^[a-z][a-z\s]*$/i.test(e)
}

lib.isEmail = (e) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(e).toLowerCase())
}

lib.currencyFormat = (amount) => {
  const numberFormat = new Intl.NumberFormat('es-CO', {
    style: 'currency', currency: 'COP', minimumFractionDigits: 0,
  })
  return numberFormat.format(amount)
}

lib.currencyFormatPesos = (number, decimals = 0, decPoint = ',', thousandsSep = '.') => {
  // https://www.it-swarm-es.com/es/javascript/como-imprimir-un-numero-con-comas-como-miles-de-separadores-en-javascript/969582846/
  // https://es.coredump.biz/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  var toFixedFix = function (n, prec) {
    // Fix for IE parseFloat(0.55).toFixed(0) = 0
    var k = Math.pow(10, prec)
    return Math.round(n * k) / k
  }
  var s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return '$' + s.join(dec)
}
// Only role with permissions for delete or update in observer(trigger click) disabled delete by same user with permission
lib.hierarchy = (roleCreator, roleObserved, userRole) => {
  if (roleObserved !== lib.consts.roles.ESTUDIANTE) {
    if (userRole === lib.consts.rolesText.ADMIN) {
      return true
    } else if (userRole === lib.consts.rolesText.ADMIN_ACADEMICO) {
      return roleCreator !== lib.consts.roles.ADMIN
    } else if (userRole === lib.consts.rolesText.PSICOLOGO) {
      return !(([lib.consts.roles.ADMIN, lib.consts.roles.ADMIN_ACADEMICO]).includes(roleCreator))
    } else if (userRole === lib.consts.rolesText.COORDINADOR) {
      return !(([lib.consts.roles.ADMIN, lib.consts.roles.ADMIN_ACADEMICO, lib.consts.roles.PSICOLOGO]).includes(roleCreator))
    } else if (userRole === lib.consts.rolesText.ADMIN_RESTAURANTE) {
      return roleCreator !== lib.consts.roles.ADMIN
    } else { return false }
  } else return true
}

lib.validateDV = (nit) => {
  const vpri = new Array(16)
  let z = nit.length
  z = nit.length
  vpri[1] = 3
  vpri[3] = 13
  vpri[4] = 17
  vpri[5] = 19
  vpri[6] = 23
  vpri[7] = 29
  vpri[8] = 37
  vpri[9] = 41
  vpri[10] = 43
  vpri[11] = 47
  vpri[12] = 53
  vpri[13] = 59
  vpri[14] = 67
  vpri[15] = 71
  vpri[2] = 7

  let x = 0
  let y = 0
  for (let i = 0; i < z; i += 1) {
    y = (nit.substr(i, 1))
    x += (y * vpri[z - i])
  }

  y = x % 11
  return (y > 1) ? 11 - y : y
}

lib.showErrorMessage = (objectConsult) => {
  if (objectConsult.response !== undefined && Object.keys(objectConsult.response).length > 0) {
    if (Object.prototype.hasOwnProperty.call(objectConsult, 'data')) {
      if (Object.prototype.hasOwnProperty.call(objectConsult.data, 'message')) {
        return objectConsult.data.message
      } else return ''
    } else if (Object.prototype.hasOwnProperty.call(objectConsult, 'response')) {
      if (Object.prototype.hasOwnProperty.call(objectConsult.response, 'data')) {
        if (Object.prototype.hasOwnProperty.call(objectConsult.response.data, 'msg')) {
          return objectConsult.response.data.msg
        } else if (Object.prototype.hasOwnProperty.call(objectConsult.response.data, 'errors')) {
          if (Object.prototype.hasOwnProperty.call(objectConsult.response.data.errors, 'msg')) {
            return objectConsult.response.data.errors.msg
          } else return ''
        } else if (Object.prototype.hasOwnProperty.call(objectConsult.response.data, 'error')) {
          if (Object.prototype.hasOwnProperty.call(objectConsult.response.data.error, 'message')) {
            return objectConsult.response.data.error.message
          } else return ''
        }
      } else return ''
    } else {
      return objectConsult
    }
  } else {
    return 'No es posible conectar con el servidor'
  }
}
module.exports = lib
